<template>
  <div class="login d-flex column_sp">
    <section class="box_2column">
      <h2>紹介者がいる方</h2>
      <p class="text-center">会員登録申込みフォームへお進みください。</p>
      <div class="">
        <div class="box-p-20 text-center">
          <!-- CGI 呼び出し -->
          <router-link
            :to="{ path: '/serial', query: { ref: ref } }"
            class="btn d-inline-block"
            >会員登録申込みフォーム</router-link
          >
        </div>
      </div>
    </section>
    <section class="box_2column">
      <h2>紹介者がいない方</h2>
      <p class="text-center">お問い合わせフォームよりご連絡ください。</p>
      <div class="box-p-20 text-center">
        <!-- CGI 呼び出し -->
        <router-link
          :to="{ path: '/contact', query: { ref: ref } }"
          class="btn d-inline-block"
          >お問い合わせフォーム</router-link
        >
      </div>
    </section>
  </div>

  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>

<script>
export default {
  mounted() {
    window.scroll(0, 0);
  },
  data() {
    return {
      ref: "admission",
    };
  },
};
</script>
